import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { Button, MaterialIcon /** Popper */ } from '@pearsontechnology/aero-components';
import color from 'tinycolor2';
import EnrolledStudentsCard from './EnrolledStudentsCard';
import AccountSummary from '../../Grid/AccountSummary';
import OutsideAlerter from './OutsideAlerter';

const StudentSummaryButton = styled(Button)`
  width: 100%;
  padding: 0 8px;
  text-transform: none;
  font-weight: 400;
  font-size: 14px;
  background: ${(props) => color(props.theme['color.text.body']).setAlpha(0.1).toString()};
  justify-content: flex-start;
  letter-spacing: 0;

  & > span {
    width: 100%;
  }

  i {
    margin-left: auto;
  }
`;

function StudentSummaryContainer({ activeStudent, list, constantRoute, maxScore, attemptId, ...props }) {
  const [toggleState, setToggleState] = useState(false);
  const toggle = () => {
    setToggleState(toggleState === false);
  };

  return (
    <Fragment>
      <OutsideAlerter onClick={toggleState ? toggle : () => {}}>
        <StudentSummaryButton grey onClick={toggle}>
          <AccountSummary account={activeStudent} />
          <MaterialIcon id="arrow_drop_down" />
        </StudentSummaryButton>
        <Transition
          in={toggleState}
          timeout={{ enter: 300, exit: 400 }}
          onEnter={(node) => node && node.offsetHeight}
          mountOnEnter
          unmountOnExit
        >
          {(status) => (
            <EnrolledStudentsCard
              list={list}
              activeStudent={activeStudent}
              constantRoute={constantRoute}
              maxScore={maxScore}
              attemptId={attemptId}
              status={status}
              {...props}
            />
          )}
        </Transition>
      </OutsideAlerter>
    </Fragment>
  );
}

StudentSummaryContainer.propTypes = {
  constantRoute: PropTypes.string,
  activeStudent: PropTypes.object,
  list: PropTypes.array,
  cohortId: PropTypes.string,
  deploymentId: PropTypes.string,
  attemptId: PropTypes.string,
  maxScore: PropTypes.number,
};

export default StudentSummaryContainer;
